import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

type ParentControllerDevice = {
  deviceId: string;
  type: string;
  name: string;
  engineeringId: string;
};

type UseGetParentControllersParams = {
  deviceType: string;
  options?: { enabled: boolean };
  queryKeys?: string[];
};

function useGetDevicesParentControllers({
  deviceType,
  options,
  queryKeys,
}: UseGetParentControllersParams) {
  const enabled = options?.enabled ?? true;
  const extraQueryKeys = queryKeys ?? [];

  return useApiQuery<{ devices: ParentControllerDevice[] }>({
    queryKey: [QueryKeys.parentControllers, deviceType, ...extraQueryKeys],
    apiPath: `/devices/parent-controllers?deviceType=${encodeURIComponent(deviceType)}`,
    method: 'GET',
    useV2API: true,
    enabled,
  });
}

export default useGetDevicesParentControllers;
